import React from "react";
import Header from "./header";
import Footer from "./footer";

export default function PublicLayout({ children }: React.PropsWithChildren) {
    return (
        <>
            <Header />
            {children}
            <Footer />
        </>
    )
}
